module.exports = __webpack_public_path__ + "static/media/Dog_getting_Treat_v2.dd9e2a88.png";